/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */
import type { EnrollmentPreviewCandidateBucket } from './enrollmentPreviewCandidateBucket';
import type { EnrollmentPreviewCandidateResolvedEmailType } from './enrollmentPreviewCandidateResolvedEmailType';
import type { PreviewStepRender } from './previewStepRender';
import type { ValidationIssueResponse } from './validationIssueResponse';

/**
 * One row of the recipient list in the preview view.
 */
export interface EnrollmentPreviewCandidate {
  job_candidate_id: string;
  profile_id: string;
  /** @maxLength 200 */
  full_name: string;
  avatar_url?: string | null;
  location?: string | null;
  current_company?: string | null;
  current_company_domain?: string | null;
  current_title?: string | null;
  resolved_email?: string | null;
  resolved_email_type?: EnrollmentPreviewCandidateResolvedEmailType;
  resolved_phone?: string | null;
  resolved_linkedin_url?: string | null;
  issues?: ValidationIssueResponse[];
  bucket?: EnrollmentPreviewCandidateBucket;
  first_step_due_at?: string | null;
  has_overrides?: boolean;
  steps?: PreviewStepRender[];
}
